/* Dummy data for local preview of the Range/Menu pages before a live backend is reachable. */
import { RangeDto, MenuDto, MenuType, MenuStatus, MenuDisplayStatus, ServicePeriodDto } from '../../app/services/api/range/rangeTypes';
import { menus as demoMenus } from './menusData';
import { ranges as demoRanges } from './rangesData';
import { mockRecipesV2 } from './recipeV2Data';

const featuredMenu = demoMenus[0];
const featuredRecipeIds = Array.from(new Set(featuredMenu.courses.flatMap((course) =>
  course.dishes.map((dish) => dish.recipeId))));

export const mockFranchiseIds = [1, 2];

export const mockRanges: RangeDto[] = [
  {
    id: 1,
    franchiseId: 1,
    name: demoRanges[0].name,
    description: demoRanges[0].description,
    menuCount: 1,
    createdBy: 1,
    createdDate: '2026-08-01T09:00:00Z',
    modifiedBy: null,
    modifiedDate: null,
  },
  {
    id: 2,
    franchiseId: 1,
    name: 'Premium Range',
    description: 'Premium menu selection',
    menuCount: 3,
    createdBy: 1,
    createdDate: '2026-08-05T09:00:00Z',
    modifiedBy: 1,
    modifiedDate: '2026-08-20T14:30:00Z',
  },
  {
    id: 3,
    franchiseId: 2,
    name: 'Standard Range',
    description: null,
    menuCount: 0,
    createdBy: 1,
    createdDate: '2026-08-10T09:00:00Z',
    modifiedBy: null,
    modifiedDate: null,
  },
];

export const mockMenus: MenuDto[] = [
  {
    id: 1,
    franchiseId: 1,
    name: featuredMenu.name,
    description: featuredMenu.description,
    menuType: MenuType.Lunch,
    status: MenuStatus.Published,
    startDate: null,
    endDate: null,
    displayStatus: MenuDisplayStatus.Active,
    servicePeriodCount: 1,
    recipeCount: featuredRecipeIds.length,
    servicePeriodNames: featuredMenu.servicePeriods.map((period) => period.name),
    createdBy: 1,
    createdDate: '2026-08-01T09:00:00Z',
    modifiedBy: null,
    modifiedDate: null,
  },
  {
    id: 2,
    franchiseId: 1,
    name: 'Lunch Menu',
    description: null,
    menuType: MenuType.Lunch,
    status: MenuStatus.Published,
    startDate: null,
    endDate: null,
    displayStatus: MenuDisplayStatus.Active,
    servicePeriodCount: 1,
    recipeCount: 1,
    servicePeriodNames: ['Lunch'],
    createdBy: 1,
    createdDate: '2026-08-02T09:00:00Z',
    modifiedBy: null,
    modifiedDate: null,
  },
  {
    id: 3,
    franchiseId: 1,
    name: 'Christmas Menu',
    description: 'Festive seasonal menu',
    menuType: MenuType.AllDay,
    status: MenuStatus.Published,
    startDate: '2026-12-01T00:00:00Z',
    endDate: '2026-12-31T23:59:59Z',
    displayStatus: MenuDisplayStatus.Scheduled,
    servicePeriodCount: 0,
    recipeCount: 0,
    servicePeriodNames: [],
    createdBy: 1,
    createdDate: '2026-08-03T09:00:00Z',
    modifiedBy: 1,
    modifiedDate: '2026-08-21T10:00:00Z',
  },
  {
    id: 4,
    franchiseId: 2,
    name: 'Core Menu',
    description: null,
    menuType: null,
    status: MenuStatus.Draft,
    startDate: null,
    endDate: null,
    displayStatus: MenuDisplayStatus.Draft,
    servicePeriodCount: 0,
    recipeCount: 0,
    servicePeriodNames: [],
    createdBy: 1,
    createdDate: '2026-08-04T09:00:00Z',
    modifiedBy: null,
    modifiedDate: null,
  },
];

// Join rows: which menus belong to which range.
export const mockRangeMenus: { rangeId: number; menuId: number }[] = [
  { rangeId: 1, menuId: 1 },
  { rangeId: 2, menuId: 1 },
  { rangeId: 2, menuId: 2 },
  { rangeId: 2, menuId: 3 },
];

// Join rows: which recipes are assigned to which menu (RecipeId is a logical items.Products.Id reference).
export const mockMenuRecipes: { menuId: number; recipeId: number; displayOrder: number }[] = [
  ...featuredRecipeIds.map((recipeId, displayOrder) => ({ menuId: 1, recipeId, displayOrder })),
  { menuId: 2, recipeId: 103, displayOrder: 0 },
];

// Preview-only stand-in for the franchise's Items/Products (IsBom=true) catalogue.
export const mockRecipeCandidates: { recipeId: number; recipeName: string; category: string; franchiseId: number }[] = [
  ...featuredRecipeIds.map((recipeId) => {
    const recipe = mockRecipesV2.find((item) => item.id === recipeId);
    return {
      recipeId,
      recipeName: recipe?.customerFacingName ?? recipe?.description ?? `Recipe ${recipeId}`,
      category: recipe?.primaryCategory ?? '',
      franchiseId: 1,
    };
  }),
  { recipeId: 101, recipeName: 'Full English Breakfast', category: 'Breakfast', franchiseId: 1 },
  { recipeId: 102, recipeName: 'Pancake Stack', category: 'Breakfast', franchiseId: 1 },
  { recipeId: 103, recipeName: 'Chicken Caesar Salad', category: 'Main', franchiseId: 1 },
  { recipeId: 104, recipeName: 'Tomato Soup', category: 'Starter', franchiseId: 1 },
  { recipeId: 105, recipeName: 'Cheesecake', category: 'Dessert', franchiseId: 1 },
  { recipeId: 106, recipeName: 'Standard Burger', category: 'Main', franchiseId: 2 },
];

export const mockServicePeriods: ServicePeriodDto[] = [
  { id: 1, menuId: 1, name: 'Lunch', startTime: '12:00:00', endTime: '14:00:00', daysOfWeek: [1, 2, 3, 4, 5] },
  { id: 2, menuId: 2, name: 'Lunch', startTime: '12:00:00', endTime: '14:00:00', daysOfWeek: [1, 2, 3, 4, 5] },
];
